const PropertyBar = ({ value, label, max = 10 }) => {
  const percentage = (value / max) * 100;
  const level = percentage < 33 ? "low" : percentage < 66 ? "medium" : "high";

  return (
    <div className="property-item">
      <div className="flex justify-between items-center">
        <span className="property-label">{label}</span>
        <span className="font-mono text-sm">{value.toFixed(1)}</span>
      </div>
      <div className="property-bar">
        <div className={`property-bar-fill ${level}`} style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
};

export default PropertyBar;
